module.exports = require("core-js/modules/es.reflect.get.js");